import { Checkbox as CheckboxPrimitive } from "radix-ui";
import type * as React from "react";
import { IndicatorCheck } from "../../icons.ts";
import { cn } from "../../lib/cn.ts";

/*
 * 24px, not shadcn's 16px. WCAG 2.5.8 sets a 24×24 CSS-pixel floor on a pointer target, and
 * this component's whole target is the box: shadcn's `Field` associates the label with
 * `htmlFor` rather than wrapping the control, so clicking the label does not enlarge the
 * checkbox's own rect the way the old nested-label markup did. `e2e/settings.e2e.ts` runs axe
 * over the holiday list and catches this the moment it shrinks back.
 */
function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer size-6 shrink-0 rounded-xs border border-input bg-surface-1 transition-shadow outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-primary",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <IndicatorCheck className="size-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
